module.exports = __webpack_public_path__ + "86f5655938c40b4e402fd7248f4085a4.svg";